import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Image } from "react-bootstrap";
import arrowleft from "../images/arrowleft.png";
import arrowright from "../images/arrowright.png";

const imageVariantsLeft = {
  hidden: { x: -80, opacity: 0, scale: 0.8 },
  visible: { 
    x: 0, 
    opacity: 1, 
    scale: 1, 
    transition: { duration: 0.5, ease: "easeOut" }
  }
};

const imageVariantsRight = {
  hidden: { x: 30, opacity: 0, scale: 0.9 },
  visible: { 
    x: 0, 
    opacity: 1, 
    scale: 1, 
    transition: { duration: 0.5, ease: "easeOut" } 
  }
};


const containerVariants1 = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const letterVariants1 = {
  hidden: { y: -10, opacity: 0 },
  visible: { 
    y: [10, -10, 0],
    opacity: 1, 
    transition: { duration: 0.5, ease: "easeInOut" }
  }
};


const Work = () => {

  const text = "We have planned, designed, built, and supported 100s of websites.";
  return (
    <section id="work" className="container py-5 ">
    <div className="row hero-section">
      <div className="col-lg-8 text-center text-lg-start">
      <motion.h2
      className="font-mont text-custom-purple"
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      We make <br /> education click
    </motion.h2>


    <motion.p
      className="text-custom"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3, duration: 0.5, ease: "easeInOut" }}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed imperdiet
      magna nisi, acra massa rhoncus vel. Morbi pellentesque nisl a nibh
      blandit gravida. Interdum et malesuada fames ac ante ipsum primis in
      faucibus.
    </motion.p>

      </div>
    </div>
    <div className="row">
        <div className="col-lg-12 d-flex justify-content-lg-end mt-4">
      <a href="#" className="custom-button d-flex">
        <motion.span
           initial={{ opacity: 0, y: -50 }}
           whileInView={{ opacity: 1, y: 0 }}
           transition={{ duration: 0.5 }}
          className="mx-2"
        >
          DESIGNED
        </motion.span>
        |
        <motion.span
         initial={{ opacity: 0, x: -50 }}
         whileInView={{ opacity: 1, x: 0 }}
         transition={{ duration: 0.5 }}
          className="mx-2"
        >
          BUILT
        </motion.span>
        |
        <motion.span
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="mx-2"
        >
          SUPPORTED
        </motion.span>
      </a>
    </div>
    </div>


    
      <div className="container work-section py-5">
        <div className="row">
          <div className="col-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
          >
            <h3 className="text-custom-work text-center text-lg-start mt-4">
              Work
            </h3>
            <div className="underline"></div>
          </motion.div>
        </div>
        </div>

  
  <div className="row align-items-center mt-4">
    
        <div className="col-lg-8  col-sm-12 text-center text-md-start">
          <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.5 }}
            variants={{
              visible: { transition: { staggerChildren: 0.05 } },
            }}
            className="fw-semibold"
            style={{
              fontSize: "18px",
              display: "inline-block",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word", 
            }}
          >
            {text.split("").map((char, index) => (
              <motion.span
                key={index}
                variants={{
                  hidden: { opacity: 0, y: index % 2 === 0 ? -10 : 10 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
                }}
                style={{
                  display: "inline-block",
                  marginRight: char === " " ? "5px" : "0px",
                }}
              >
                {char}
              </motion.span>
            ))}
          </motion.p>
        </div>

    
        <div className="col-lg-4 d-flex justify-content-center justify-content-lg-end mt-3 mt-lg-0">
          <button id="prevBtn" className="stand4 prev-btn mx-2">
            <motion.div 
              variants={imageVariantsLeft}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }} 
            >
              <Image src={arrowleft} alt="Mockup" className="arrow-image1" width={40} height={40} />
            </motion.div>
          </button>

          <button id="nextBtn" className="stand4 next-btn mx-2">
            <motion.div variants={imageVariantsRight} initial="hidden" whileInView="visible">
              <Image src={arrowright} alt="Mockup" className="arrow-image1" width={40} height={40} />
            </motion.div>
          </button>
        </div>


  </div>
</div>

    </section>
  );
};

export default Work;
